import request from '@/utils/request'

/**
 * AI创作工坊相关 API
 */

// 课程列表
export function courseList (data) {
  return request({
    url: '/course/member/course_list',
    method: 'post',
    data
  })
}

/* 创建课程（POST /course/member/course_add，成功时 data 直接返回课程 id，如 "980"） */
export function courseAdd (data) {
  return request({
    url: '/course/member/course_add',
    method: 'post',
    data
  })
}

// 修改课程
export function courseEdit (data) {
  return request({
    url: '/course/member/course_edit',
    method: 'post',
    data
  })
}

// 删除课程
export function courseDelete (data) {
  return request({
    url: '/course/member/course_delete',
    method: 'post',
    data
  })
}

// 创建章节
export function chapterAdd (data) {
  return request({
    url: '/course/member/chapter_add',
    method: 'post',
    data
  })
}

// 修改章节
export function chapterEdit (data) {
  return request({
    url: '/course/member/chapter_edit',
    method: 'post',
    data
  })
}

// 删除章节
export function chapterDelete (data) {
  return request({
    url: '/course/member/chapter_delete',
    method: 'post',
    data
  })
}

/** 获取图片内容（POST /course/member/receive_image_content，参数: images 为图片 id 逗号拼接，request_id 幂等键建议前端生成）
 * data: words[]、sentences[]、request_id、record_id?（落库成功才有）、
 * billing: { status, model_points, asr_points, total_points, estimated_points, balance, required_points, shortage_points }
 */
export function getImageContent (data) {
  return request({
    url: '/course/member/receive_image_content',
    method: 'post',
    data
  })
}

/** 图片识别历史列表（POST /course/member/recognition_history，参数: page?, page_size?, status? 1待使用|2已使用） */
export function recognitionHistory (data) {
  return request({
    url: '/course/member/recognition_history',
    method: 'post',
    data
  })
}

/** 图片识别详情（POST /course/member/recognition_detail，参数: id；status 1待使用|2已使用） */
export function recognitionDetail (data) {
  return request({
    url: '/course/member/recognition_detail',
    method: 'post',
    data
  })
}

/**
 * 识别结果选课添加章节（POST /course/member/recognition_create_course）
 * 参数: id, course_id?(>0 已有课 / 0 新建), course_title?(新建必填), course_intro?, course_image?,
 * word_chapter_title?, word_chapter_intro?, sentence_chapter_title?, sentence_chapter_intro?,
 * with_words?, with_sentences?；成功后记录不可重复使用
 */
export function recognitionCreateCourse (data) {
  return request({
    url: '/course/member/recognition_create_course',
    method: 'post',
    data
  })
}

/** 章节题目列表（POST /course/member/question_list，参数: course_id, chapter_id, page?, page_size?） */
export function questionList (data) {
  return request({
    url: '/course/member/question_list',
    method: 'post',
    data
  })
}

/** 题目详情（POST /course/member/question_detail，参数: id；编辑回显 7 字段） */
export function questionDetail (data) {
  return request({
    url: '/course/member/question_detail',
    method: 'post',
    data
  })
}

/** 编辑题目（POST /course/member/question_edit，参数: id + en/zh/phonetic_us/phonetic_uk/word_components/word_defs/word_en 至少一项；人工编辑置 ai_status=1，不触发 AI） */
export function questionEdit (data) {
  return request({
    url: '/course/member/question_edit',
    method: 'post',
    data
  })
}

/** 删除题目（POST /course/member/question_delete，参数: id；物理删除 w_en_question + v2） */
export function questionDelete (data) {
  return request({
    url: '/course/member/question_delete',
    method: 'post',
    data
  })
}
